/**
 * Shared utilities for automated flight & quote status transitions.
 *
 * Quote status rules (from spec):
 *   Any flight DIVERTED    → Quote DIVERTED
 *   Any flight IN_TRANSIT  → Quote IN_TRANSIT
 *   ALL flights COMPLETED  → Quote COMPLETED
 *   ALL flights CANCELLED  → Quote CANCELLED
 */
import { apiClient } from '@/lib/api';

/**
 * Fetch all flights on a quote, apply `newFlightStatus` for `updatedFlightId`
 * in memory, then return the appropriate new quote status (or null if no change).
 */
export async function deriveQuoteStatus(quoteId, updatedFlightId, newFlightStatus) {
  try {
    const data = await apiClient.getFlights({ quote_id: quoteId });
    const allFlights = Array.isArray(data) ? data : [];
    if (!allFlights.length) return null;

    const statuses = allFlights.map((f) =>
      f.id === updatedFlightId
        ? newFlightStatus
        : (f.flight_status || 'POSITIONING').toUpperCase()
    );

    if (statuses.some((s) => s === 'DIVERTED')) return 'DIVERTED';
    if (statuses.some((s) => s === 'IN_TRANSIT')) return 'IN_TRANSIT';
    if (statuses.every((s) => s === 'COMPLETED')) return 'COMPLETED';
    if (statuses.every((s) => s === 'CANCELLED')) return 'CANCELLED';

    return null;
  } catch (err) {
    console.error('[flightStatusUtils] deriveQuoteStatus failed:', err);
    return null;
  }
}
